var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90mm",
    height: "90mm",
    viewBox: "0 0 1814.173 1814.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 97.041,
    x2: 79.094,
    y1: 61.626,
    x1: 41.758,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 90.091,
    x2: 205.437,
    y1: 54.676,
    x1: 168.102,
    gradientUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 357.993,
    x2: 265.133,
    y1: 404.246,
    x1: 267.326,
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0e0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 401.625,
    x2: 276.346,
    y1: 401.625,
    x1: 221.468,
    gradientUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#313437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 394.53,
    x2: 240.752,
    y1: 394.53,
    x1: 233.132,
    gradientUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#ff9f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#ffb000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ffbe00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#ffb100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 406.633,
    x2: 261.627,
    y1: 406.633,
    x1: 254.007,
    gradientUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#ff9f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#ffb000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ffbe00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#ffb100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 416.063,
    x2: 281.082,
    y1: 416.063,
    x1: 270.331,
    gradientUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#383b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#161617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0e0f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 420.05,
    x2: 289.861,
    y1: 420.05,
    x1: 278.197,
    gradientUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff920a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaf4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 393.52,
    x2: 275.862,
    y1: 393.52,
    x1: 269.673,
    gradientUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaf4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#ffa83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#ff9715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff920a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 389.215,
    x2: 287.783,
    y1: 389.215,
    x1: 257.973,
    gradientUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaf4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#ffa83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#ff9715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff920a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 383.674,
    x2: 295.86,
    y1: 383.674,
    x1: 249.238,
    gradientUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaf4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#ffa83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#ff9715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff920a"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 31.096,
    width: 44.8,
    y: 58.782,
    x: 34.454,
    filterUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 31.096,
    width: 44.8,
    y: 51.832,
    x: 160.797,
    filterUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 27,
    width: 69,
    y: 128.506,
    x: 253.37,
    filterUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "back",
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1048.568 1482.681c-131.94-76.172-63.49-253.234 50.12-309.355 113.574-56.12 646.705-323.333 646.705-323.333l-.204 33.272s-496.007 251.809-631.41 322.445c-58.323 30.495-96.854 88.355-99.705 152.03-2.87 65.34 52.861 116.887 86.892 98.668 113.203-60.712 655.684-357.42 655.684-357.42l.278 31.494s-578.882 318.945-649.537 355.772c-25.533 13.276-58.823-3.573-58.823-3.573z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.349 1419.303c18.478 31.458 49.584 48.936 71.636 37.105 113.203-60.712 655.684-357.42 655.684-357.42l-28.106-16.276-79.45-45.825 17.775 67.062s-549.647 293.358-576.031 307.837c-45.659 24.625-61.508 7.517-61.508 7.517z",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.437 902.28s-455.922 232.775-591.25 303.43c-58.361 30.495-96.91 88.355-99.724 152.03-1 23.107 5.24 44.344 15.238 61.563 0 0 15.886 17.108 61.526-7.499 26.403-14.479 612.673-326.962 612.673-326.962s-44.048 9.646-45.196-57.139c-1.092-66.692 46.733-125.423 46.733-125.423z",
    fill: "var(--text-color-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.146 1385.716c2.833-63.674 41.4-121.553 99.76-152.03 111.426-58.23 440.24-226.313 552.87-283.821 12.997-27.977 28.013-46.437 28.013-46.437s-455.866 232.738-591.232 303.374c-58.305 30.514-96.872 88.355-99.668 152.085-.963 21.663 4.517 41.66 13.46 58.268-2.407-9.924-3.666-20.478-3.203-31.439z",
    opacity: 0.23,
    fill: "#606060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.874 379.18c-5.958 3.29-9.62 12.548-2.555 16.631l48.87 28.214c-7.126-4.114-3.429-13.677 2.707-16.708 6.134-3.031 34.928-17.463 34.928-17.463l-48.436-26.595s-24.229 10.113-33.165 14.696c0 0 .042.904-.754 1.41 0 0-.743.562-1.571-.149l-.024-.036z",
    fill: "url(#f)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.932 379.232l48.414 28.405c-5.785 3.323-9.04 12.422-2.137 16.405l-48.871-28.214c-7.057-4.08-3.407-13.324 2.54-16.621l.054.025z",
    fill: "url(#g)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.752 386.77l-1.156-.678-.054-.023c-5.948 3.295-9.597 12.54-2.54 16.62l.525.301c-5.74-4.361-2.337-12.882 3.225-16.22z",
    fill: "var(--accent-color)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.626 398.919l-1.155-.675-.055-.023c-5.948 3.278-9.596 12.468-2.538 16.523l.523.302c-5.739-4.336-2.337-12.808 3.225-16.127z",
    fill: "var(--accent-color)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.978 1152.497l-.111.037-904.993-522.67c-.315 16.59-12.054 29.92-26.496 29.92-3.222 0-6.295-.777-9.22-2.018l888.33 521.17a.793.793 0 00.332-.148c.056.13.037.315.186.39 4.258 3.999 11.83 15.997 24.292 15.997 16.09 0 29.254-13.331 29.254-23.996 0-5.796 1.11-14.035-1.574-18.682zm-51.935 26.18c3.314-1.888 6.61-3.703 10.016-5.332 8.85-4.388 20.46-10.128 34.013-16.886l-44.03 22.218z",
    fill: "#4d4d4d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.067 666.95s-34.457 18.312-58.86 60.916l888.978 499.285s24.366-32.495 54.824-44.678L185.067 666.95z",
    opacity: 0.47,
    fill: "var(--text-color-2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M276.407 407.634l.575 1.87s-6.113 3.596-4.315 9.854c0 0 .937 3.38 4.1 3.451l3.812-2.085.505 1.511-3.451 1.941s-4.131 1.773-6.403-3.094c-2.014-4.314-.308-7.812 1.87-10.716 1.078-1.437 3.307-2.732 3.307-2.732z",
    fill: "url(#j)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 1354.425s135.643-62.304 159.232-78.912c0 0-99.705 38.752-159.232 78.912z",
    fill: "var(--text-color-2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.197 415.677l1.348-.6s.569 1.725 1.832 2.577c1.829 1.237 4.522-.033 5.346 2.06.516 1.32.896 3.89 3.139 4.038 0 0-.374 1.195-.898 1.271 0 0-1.868-.374-2.691-1.945-.994-1.896-.299-2.915-1.941-3.063-1.648-.151-5.087-.45-6.135-4.338z",
    fill: "var(--accent-color)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fill: "gray",
    d: "M1142.237 1137.666L408.807 730.55l731.171 421.947 605.415-302.504z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M275.509 392.069c.792 1.498.206 3.36-1.31 4.16-1.513.801-3.381.237-4.174-1.26-.792-1.496-.205-3.359 1.309-4.16 1.515-.8 3.384-.237 4.175 1.26z",
    fill: "var(--accent-color)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M262.887 389.671l-4.914-2.73s17.381-9.857 29.81 5.151l-4.866 2.574c0 .001-7.199-10.911-20.03-4.995z",
    fill: "var(--accent-color)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M254.243 384.727l-5.005-2.608s26.724-15.471 46.622 5.885l-5.309 2.642c0-.001-14.833-17.445-36.308-5.919z",
    fill: "var(--accent-color)",
    transform: "matrix(18.51535 0 0 18.51535 -4028.139 -6368.292)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooked);
export default __webpack_public_path__ + "static/media/booked.f8195d48.svg";
export { ForwardRef as ReactComponent };